<pop-error-wrapper>
  <h1 title
      translate="USER.ISLOCKED"></h1>
  <p description
     translate="USER.TRY_ASSOCIATE"></p>
  <button action
          class="pl-button"
          (click)="retryAction()"
          translate="USER.RETRY_ASSOCIATE"></button>
</pop-error-wrapper>
